import { addTrailingZeros } from "@js-app/services/helpers/math";

export function formatCoinsToText(coins) {
  return addTrailingZeros((parseInt(coins || 0) / 100).toLocaleString());
}

export function formatCoinsToNumber(coins) {
  return parseInt(coins || 0) / 100;
}

export function formatStringNumberToCoin(coins) {
  let _number = parseFloat(coins || 0) * 100;
  return Number.isNaN(_number) ? 0 : _number;
}
